export let projectsRecordsDetailCN: Record<string, Array<string>> = {
  "参与开发澳大利亚 Covid-19 信息追踪网站": [
    "https://covid-19-au.com/",
    "项目在 GitHub 上开源：https://github.com/covid-19-au/covid-19-au.github.io"
  ],
  "Australia National Missing Person Hackathon": [
    "CTF 竞赛，使用 OSINT（开源情报搜集）根据澳大利亚政府给出的信息寻找失踪人口。",
    "获得由举办方 Trace Labs 颁发的奖章。"
  ],
  "Cyber Security Challenge Australia 2018": [
    "澳大利亚最高级别的本科学生 CTF 竞赛。由澳大利亚政府主办，多个行业领导公司提供实战题目，包括 PwC，思科，微软等。",
    "学习 SQL 注入，代码注入，网页应用渗透，并运用于实战，找到 flag。"
  ],
  "2018 Downer Spotless Hack the city Hackathon": [
    "根据企业给出的问题进行分析，画出原型图，并使用 React-Native 写出 MVP，最小化可行产品。"
  ],
  "2018 PTC IoT/AR Hackathon": [
    "一场基于 IoT 以及 AR 技术的黑客马拉松。根据企业问题提供解决方案",
    "学习并运用由 PTC 提供的 IoT，AR 工具 ThingWorx",
    "获得了由 Hendry Group 颁发的最具创新性奖。"
  ]
};

export let projectsRecordsDetailEN: Record<string, Array<string>> = {
  "Australia Covid-19 Tracking Website": [
    "Help to develop one Australia Covid-19 Tracking Website. https://covid-19-au.com/",
    "Open-sourced on GitHub: https://github.com/covid-19-au/covid-19-au.github.io"
  ],
  "Australia National Missing Person Hackathon": [
    "A CTF event to find information about missing person reported in Australia",
    "An official badge offered by Trace Labs."
  ],
  "Cyber Security Challenge Australia 2018": [
    "Come 20th out of 100 teams",
    "Learn and applied SQL injection, web application penetration testing and code injection"
  ],
  "2018 Downer Spotless Hack the city Hackathon": [
    "Got 2nd place out of 18 teams.",
    "Build prototype of a shift management app using react-native."
  ],
  "2018 PTC IoT/AR Hackathon": [
    "Got 2nd out of 10 teams.",
    "We were regarded as the most innovative solution by Hendry Group."
  ]
};
